<template>
  <v-alert
    :value="displayBanner"
    outlined
    dense
    type="warning"
    prominent
    border="left"
    class="mt-0"
    style="color: rgba(0,0,0,.54); border-radius: 0 !important;"
  >
    <v-row align="center">
      <v-col class="grow">
        Please verify your email in order to gain full access to {{ companyName() }}.
      </v-col>
      <v-col class="shrink">
        <v-btn
          :disabled="!canResend"
          small
          outlined
          rounded
          style="color: rgba(0,0,0,.54)"
          class="my-0 ml-4"
          color="primary"
          @click="send"
          v-text="canResend ? 'Resend Email' : 'Sent'"
        />
      </v-col>
    </v-row>
  </v-alert>
</template>
<script>
  import { mapGetters, mapActions} from 'vuex'

  export default {
    data() {
      return {
        canResend: true
      }
    },
    computed: {
      ...mapGetters([ 'isEmailVerified', 'isLoggedIn']),
      displayBanner() {
        return !this.isEmailVerified && this.isLoggedIn
      }
    },
    mounted() {

    },
    methods: {
      ...mapActions([ 'sendVerifyEmail']),
      companyName() {
        return process.env.VUE_APP_COMPANY_NAME
      },
      send() {
        this.sendVerifyEmail()
        this.canResend = false
      }
    }
  }
</script>
